import {
  TableSortLabel,
  Autocomplete,
  Paper,
  TextField,
  Alert,
  IconButton,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import DownloadIcon from "@mui/icons-material/Download";
import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import {
  getSelectedTimePeriod,
  roundStringNumberToInt,
} from "../../helpers/businessleaderDashboardHelpers";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import dayjs from "dayjs";
import {
  brandPerformanceAll,
  brandPerformanceIncome,
  brandPerformancePerformance,
  brandPerformanceUserBehavior,
} from "./AdditionalQueriesConstants";
import { buiDashboardEndPointLogic } from "../../../../../../logic/AssetManagement/overview/BusinessLeaderDashboard/buiDashboardEndPointLogic";
import { useSelector } from "react-redux";
import {
  selectUserToken,
  setDisplayErrorSnackBar,
  setIsLoading,
} from "../../../../../../features/userSlice";
import { trackPromise } from "react-promise-tracker";
import store from "../../../../../../store";
import { QueryIDsBusinessLeaderDashBoard } from "../../../../../../pages/AssetManagement/Overview/BusinessLeaderDashboard/logic/QueryIDsBusinessLeaderDashBoard";
import { Stack } from "@mui/system";
import { saveAs } from "file-saver";
import DatacollectionLastRun from "./DatacollectionLastRun";

export const BrandPerformance = React.memo(() => {
  const [brandPerformanceData, setBrandPerformanceData] = useState([]) as any;
  const [dataLastDataRetrieval, setDataLastDataRetrieval] = useState([]) as any;

  const authToken = useSelector(selectUserToken)?.toString();

  const {
    selectedSharedUidBui,
    selectedDimensions,
    selectedType,
    selectedAll,
  } = useSelector((state: any) => state?.businessLeaderDashBoard);

  const tableHeadingsbrandPerformancePerformance = brandPerformancePerformance;
  const tableHeadingsbrandPerformanceIncome = brandPerformanceIncome;
  const tableHeadingsbrandPerformanceUserBehavior =
    brandPerformanceUserBehavior;
  const headCells = brandPerformanceAll;

  const [selectedTimeFrame, setSelectedTimeFrame] = useState("MTD") as any;
  const [selectedBrandName, setSelectedBrandName] = useState<string | null>(
    null,
  ); // for brand name filter
  const [visibleColumns, setVisibleColumns] = useState(headCells);

  const [filteredData, setFilteredData] = useState([]);
  const [allBrandNamesRows, setAllBrandNamesRows] = useState<string[]>([]); // for brand name filter
  // const [, setAllBrandNamesRows] = useState([]);
  // for alert message
  const datesForFirstTimeLoading = getSelectedTimePeriod("MTD"); // for first time loading
  const [savedStartDate, setSavedStartDate] = useState(
    datesForFirstTimeLoading.startDate,
  ) as any;
  const [savedEndDate, setSavedEndDate] = useState(
    datesForFirstTimeLoading.endDate,
  ) as any;

  const [selectedValue, setSelectedValue] = useState("All"); // Default selection

  const [order, setOrder] = useState("asc") as any;
  const [orderBy, setOrderBy] = useState("ftd") as any;

  const getBrandPerforamnceData = async (
    startDate?: string,
    endDate?: string,
  ) => {
    try {
      store.dispatch(setIsLoading(true));
      let currentStartDate = savedStartDate;
      let currentEndDate = savedEndDate;
      if (startDate && endDate) {
        currentStartDate = startDate;
        currentEndDate = endDate;
      }
      await buiDashboardEndPointLogic.getBuiDashboardData_brandPerformance(
        authToken as string,
        selectedSharedUidBui,
        QueryIDsBusinessLeaderDashBoard.brandPerformanceId,
        trackPromise,
        setBrandPerformanceData,
        selectedDimensions,
        selectedType,
        selectedAll,
        currentStartDate,
        currentEndDate,
      );
      await buiDashboardEndPointLogic.getBuiDashboardData_brandPerformance_lastDataRetrieval(
        authToken as string,
        selectedSharedUidBui,
        trackPromise,
        setDataLastDataRetrieval,
        selectedDimensions,
        selectedType,
        selectedAll,
        currentStartDate,
        currentEndDate,
      );
    } catch (error: any) {
      console.error("Error getting BUI dashboard data", error);
    } finally {
      store.dispatch(setIsLoading(false));
    }
  };

  useEffect(() => {
    getBrandPerforamnceData();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (brandPerformanceData?.query_output?.length > 0) {
      setFilteredData(brandPerformanceData?.query_output);
      const brandNames = brandPerformanceData.query_output
        .map((obj: any) => obj?.brand)
        .filter(
          (brandName: unknown): brandName is string =>
            typeof brandName === "string" &&
            brandName.trim().length > 0 &&
            brandName !== "null",
        );
      setAllBrandNamesRows([...new Set<string>(brandNames)]);
      setSelectedBrandName(null);
      handleRequestSort("ftd", "asc");
    } else {
      setFilteredData([]);
      setAllBrandNamesRows([]);
      setSelectedBrandName(null);
    }
    // eslint-disable-next-line
  }, [brandPerformanceData]);

  const parseValue = (value: any) => {
    if (typeof value === "string") {
      if (value.includes("%")) {
        return parseFloat(value.replace("%", ""));
      }
      if (value.includes("$")) {
        return parseFloat(value.replace("$", ""));
      } else {
        return value.toLowerCase();
      }
    } else if (value === null || !value) {
      return "";
    }
    return value;
  };

  const handleRequestSort = (property: any, orderRender: any) => {
    const isAscending = orderBy === property && orderRender === "asc";
    const newOrder = isAscending ? "desc" : "asc";
    setOrder(newOrder);
    setOrderBy(property);

    const sortedRows = [...brandPerformanceData?.query_output].sort((a, b) => {
      const aValue = parseValue(a[orderBy]);
      const bValue = parseValue(b[orderBy]);

      if (aValue < bValue) {
        return newOrder === "asc" ? -1 : 1;
      }
      if (aValue > bValue) {
        return newOrder === "asc" ? 1 : -1;
      }
      return 0;
    }) as any;

    setFilteredData(sortedRows);
  };

  const handleChange = (event: any) => {
    setSelectedValue(event.target.value);
  };

  const timeFrame = [
    { label: "MTD" },
    { label: "Yesterday" },
    { label: "Last 7 Days" },
    { label: "Last Month" },
    { label: "YTD" },
  ];

  const handleTimeFrameChange = (_: unknown, value: any) => {
    setSelectedTimeFrame(value?.label);
    setSelectedBrandName(null);
    const dates = getSelectedTimePeriod(value?.label);
    if (dates.endDate && dates.startDate) {
      setSavedStartDate(dates.startDate);
      setSavedEndDate(dates.endDate);
      getBrandPerforamnceData(dates.startDate, dates.endDate);
    } else {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "No Dates Choosen",
          type: "error",
        }),
      );
    }
  };

  // Handle radio button changes
  const handleRadioChange = (event: any) => {
    const selectedValue = event.target.value;

    // Set visible columns based on radio button value
    switch (selectedValue) {
      case "User Behavior":
        setVisibleColumns(tableHeadingsbrandPerformanceUserBehavior); // Show User Behavior
        break;
      case "Income":
        setVisibleColumns(tableHeadingsbrandPerformanceIncome); // Show Income
        break;
      case "Performance":
        setVisibleColumns(tableHeadingsbrandPerformancePerformance); // Show Performance
        break;
      case "All":
        setVisibleColumns(headCells); // Show All
        break;
      default:
        setVisibleColumns(tableHeadingsbrandPerformanceUserBehavior); // Default to no columns
    }
  };

  const getValueField = (key: any, value: any) => {
    if (value === 0) {
      return value;
    } else if (key === "qftd_perc" || key === "ftd_perc" || key === "roi") {
      return roundStringNumberToInt(value * 100) + "%";
    } else if (
      key !== "brand" &&
      key !== "ftd" &&
      key !== "brand_id" &&
      key !== "clicks" &&
      key !== "qftd" &&
      key !== "reg"
    ) {
      return roundStringNumberToInt(value) + "$";
    } else {
      return value === "null" || value == null ? "" : value;
    }
  };

  // filter table by brand id
  const handleBrandNameChange = (_: unknown, value: any) => {
    setSelectedBrandName(value);

    if (!value) {
      setFilteredData(brandPerformanceData?.query_output ?? []);
      handleRequestSort("ftd", "asc");
      return;
    }

    const filtered = (brandPerformanceData?.query_output ?? []).filter(
      (row: any) => row?.brand === value,
    );
    setFilteredData(filtered);
  };

  const getMetricValueForCSV = (key: any, value: any) => {
    if (value === 0) {
      return value;
    } else if (key === "qftd_perc" || key === "ftd_perc" || key === "roi") {
      value = value * 100;
      value = Math.round(value);
      return value + "%";
    } else if (
      key !== "brand" &&
      key !== "brand_display_name" &&
      key !== "ftd" &&
      key !== "brand_id" &&
      key !== "clicks" &&
      key !== "qftd" &&
      key !== "reg"
    ) {
      value = Math.round(value);
      return value + "$";
    } else {
      return value === "null" || value == null ? "" : value;
    }
  };

  const handleExportCSV = () => {
    const csvRows = [];

    // Extract the table headers
    const headers = headCells.map((pair) => pair.key) as any;
    csvRows.push(headers.join(","));

    // Extract the table data
    // eslint-disable-next-line
    filteredData.map((row: any) => {
      let rowData = [] as any;
      // eslint-disable-next-line
      headers.map((key: any) => {
        const result = getMetricValueForCSV(key, row[key]);
        if (result !== "null") {
          rowData.push(result);
        }
      });
      if (rowData?.length > 0) {
        csvRows.push(rowData.join(","));
      }
    });

    // Convert CSV rows to a single string
    const csvString = csvRows.join("\n");

    // Create a blob and download the file
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "BrandPerformance.csv");
  };

  return (
    <>
      <Grid container>
        <Grid size={12} px={2}>
          <Stack flexDirection={"row"} alignItems="center" gap={2}>
            <Alert
              sx={{
                color: "#ED6C02",
                margin: "16px",
                border: "1px solid #ED6C0280",
                width: "100%",
              }}
              severity="warning"
              icon={<InfoOutlinedIcon fontSize="inherit" />}
            >
              Data is only relevant for the period of{" "}
              {dayjs(savedStartDate).format("DD-MM-YYYY")} -{" "}
              {dayjs(savedEndDate).format("DD-MM-YYYY")}
            </Alert>
            <IconButton color="secondary" size="large" data-tracker="277">
              <DownloadIcon fontSize="medium" onClick={handleExportCSV} />
            </IconButton>
          </Stack>
        </Grid>
      </Grid>
      <Grid
        alignItems={"center"}
        container
        mt={2}
        px={2}
        columnSpacing={2}
        mb={1}
      >
        <Grid size={8} px={2}>
          <FormControl>
            <FormLabel
              color="secondary"
              id="demo-row-radio-buttons-group-label"
            >
              Data set:
            </FormLabel>
            <RadioGroup
              value={selectedValue}
              onChange={handleChange}
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
            >
              <FormControlLabel
                value="User Behavior"
                control={
                  <Radio
                    color="secondary"
                    size="small"
                    inputProps={
                      { "data-tracker": "284" } as Record<string, any>
                    }
                  />
                }
                label="User Behavior"
                onChange={handleRadioChange}
              />
              <FormControlLabel
                value="Income"
                control={
                  <Radio
                    color="secondary"
                    size="small"
                    inputProps={
                      { "data-tracker": "287" } as Record<string, any>
                    }
                  />
                }
                label="Income"
                onChange={handleRadioChange}
              />
              <FormControlLabel
                value="Performance"
                control={
                  <Radio
                    color="secondary"
                    size="small"
                    inputProps={
                      { "data-tracker": "288" } as Record<string, any>
                    }
                  />
                }
                label="Performance"
                onChange={handleRadioChange}
              />
              <FormControlLabel
                value="All"
                control={
                  <Radio
                    color="secondary"
                    size="small"
                    inputProps={
                      { "data-tracker": "289" } as Record<string, any>
                    }
                  />
                }
                label="All"
                onChange={handleRadioChange}
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid size={2} mt={1}>
          <Autocomplete
            data-tracker="285"
            sx={{ width: "100%" }}
            onChange={handleBrandNameChange}
            options={allBrandNamesRows}
            value={selectedBrandName}
            getOptionLabel={(option) => option ?? ""}
            disabled={allBrandNamesRows?.length === 0}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select Brand Name"
                label="Filter by Brand Name"
                color="secondary"
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
              />
            )}
            size="small"
          />
        </Grid>
        <Grid size={2} mt={1}>
          <Autocomplete
            data-tracker="88"
            sx={{ width: "100%" }}
            onChange={handleTimeFrameChange}
            options={timeFrame}
            value={selectedTimeFrame}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select Time Frame"
                label="Time Frame"
                color="secondary"
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
              />
            )}
            size="small"
          />
        </Grid>
      </Grid>
      <TableContainer
        className="RunRateTableWrap"
        component={Paper}
        sx={{ boxShadow: "none", maxHeight: 400, overflowY: "auto" }}
      >
        {filteredData?.length > 0 && dataLastDataRetrieval?.length > 0 ? (
          <>
            <Table aria-label="collapsible table" size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  {headCells
                    ?.filter((col: any) =>
                      visibleColumns?.some(
                        (item: any) => item["key"] === col?.key,
                      ),
                    )
                    ?.map((col: any) => (
                      <TableCell
                        key={col?.key + "TabelCell" + Math.random()}
                        align="left"
                      >
                        <TableSortLabel
                          active={orderBy === col?.key}
                          direction={orderBy === col?.key ? order : "asc"}
                          onClick={() => handleRequestSort(col?.key, order)}
                        >
                          {col?.label}
                        </TableSortLabel>
                      </TableCell>
                    ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData?.map((row: any, rowIndex: any) => (
                  <React.Fragment key={rowIndex + "filterData" + Math.random()}>
                    <TableRow
                      sx={{
                        "&:not(:last-child) > *": {
                          borderBottom:
                            "1px solid rgba(224, 224, 224, 1) !important",
                        },
                      }}
                    >
                      {headCells
                        ?.filter((col: any) =>
                          visibleColumns?.some(
                            (item: any) => item["key"] === col?.key,
                          ),
                        )
                        ?.map((col: any) => (
                          <TableCell
                            key={col?.key + "headCell" + Math.random()}
                            align="left"
                          >
                            {col?.key !== "Run" ? (
                              getValueField(col?.key, row[col?.key])
                            ) : (
                              <DatacollectionLastRun
                                data={
                                  dataLastDataRetrieval?.filter(
                                    (item: any) =>
                                      item?.brand_id === row?.brand_id,
                                  )[0]
                                }
                                brandName={row?.brand}
                              />
                            )}
                          </TableCell>
                        ))}
                    </TableRow>
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </>
        ) : (
          <Alert
            sx={{ color: "#ED6C02", mb: 1 }}
            severity="warning"
            icon={<InfoOutlinedIcon fontSize="inherit" sx={{ mr: 1 }} />}
          >
            NO DATA
          </Alert>
        )}
      </TableContainer>
    </>
  );
});
